import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import SearchView from "../../../widgets/SearchView";
import BursarySetupSearchForm from './../Bursary/BursarySetupSearchForm';
import { ViewContainer } from "./../../../View.jsx";
import ViewUtils from "./../../../ViewUtils";
import withMenuPermission from "../../../widgets/withMenuPermission";


const headCells = [
    { id: 'BursaryCode', numeric: false, disablePadding: true, label: 'Bursary Programme Code' },
    { id: 'BursaryTitle', numeric: false, disablePadding: true, label: 'Bursary Programme Title' },
    { id: 'BursaryType', numeric: false, disablePadding: true, label: 'Bursary Type' },
    { id: 'OFOOccupation', numeric: false, disablePadding: true, label: 'OFO Occupation Code' },
    { id: 'Qualification', numeric: false, disablePadding: true, label: 'Qualification' }
];


const utils = new ViewUtils();

class BursarySetupSearch extends Component {
    constructor(props) {
        super(props)

        let model = {
            BursaryCode: "",
            BursaryTitle: ""
        }

        this.searchParameters = !utils.isNull(this.props.programmeId) ?
            [
                { Name: "id", Value: this.props.programmeId },
                { Name: "BursaryCode", Value: "" },
                { Name: "BursaryTitle", Value: "" }
            ]
            :
            [
                { Name: "BursaryCode", Value: "" },
                { Name: "BursaryTitle", Value: "" },
            ]

        this.state = {
            model: model,
            selectedBursaryProgramme: null,
            keyUpSwitch: false
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: '', tooltip: 'Remove Bursary', icon: 'DeleteIcon', disabled: true, visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        }
    }

    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer title="">
                <SearchView headCells={headCells} dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/Bursarysetup/getsearch"}
                    entityViewPath='/Bursarysetup'
                    title='Bursary'
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="BursaryTitle" mode={this.props.mode}
                    keyUpSwitch={this.state.keyUpSwitch}
                    history={this.props.history}
                    multiSelect={this.props.multiSelect}
                    deleteUrl={"api/sims/BursarySetup/removeBursary"} useDeletePost={true}
                    promptTitle={"Remove Bursary Programme"} selectionCallbackMode={this.props.selectionCallbackMode}
                    promptContent={"Removing the Bursary programme is a permanent action and the Bursary programme will not be available going forward. Are you sure you want to remove this Bursary programme?"}
                >
                    <BursarySetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>

        );
    }
}

export default withRouter(withMenuPermission(BursarySetupSearch));

